"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Links = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var React = __importStar(require("react"));
var Icon_1 = require("../Icon/Icon");
require("./links.css");
var Links = function (props) {
    var renderContent = function (item) { return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: item.icon }), (0, jsx_runtime_1.jsx)("span", { children: item.label })] })); };
    var renderItem = function (item) {
        var classNames = "anchor".concat(item.disabled ? ' disabled' : '');
        switch (item.type) {
            case 'click': {
                var onItemClick = function () {
                    if (!item.disabled) {
                        item.onClick();
                    }
                };
                return ((0, jsx_runtime_1.jsx)("span", __assign({ className: classNames, onClick: onItemClick }, { children: renderContent(item) })));
            }
            case 'link': {
                var to = item.disabled ? '' : item.to;
                return item.real ? ((0, jsx_runtime_1.jsx)("a", __assign({ className: classNames, href: to, target: item.target }, { children: renderContent(item) }))) : ((0, jsx_runtime_1.jsx)(item.LinkComponent, __assign({ className: item.disabled ? 'disabled' : '', to: to }, { children: renderContent(item) })));
            }
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "panel-info-links" }, { children: (0, jsx_runtime_1.jsx)("ul", { children: props.links.map(function (item) { return ((0, jsx_runtime_1.jsx)("li", { children: renderItem(item) }, item.slug)); }) }) })));
};
exports.Links = Links;
//# sourceMappingURL=Links.js.map